// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"171":"abafc31c","610":"483bbe03"}[chunkId] + ".chunk.css";
};